import {
  useState,
  useRef,
  useEffect,
  useCallback,
  MutableRefObject,
} from 'react';
import { downloadSnapshot, extractSnapshot } from '../helpers/snapshot';
import { useMutation } from '@apollo/client';
import { TAKE_SNAPSHOT } from '../http/apollo-queries';
import { TUIMode } from '../types/model';

export const useSnapshot = (ref: MutableRefObject<HTMLElement | null>) => {
  const [takeSnapshot] = useMutation(TAKE_SNAPSHOT);
  const [loading, setLoading] = useState(false);
  const [img, setImg] = useState('');

  const snapshot = (
    w: number,
    h: number,
    fileName: string,
    theme: TUIMode,
    download: boolean
  ) => {
    setLoading(true);

    extractSnapshot(ref.current, {
      w,
      h,
      fileName,
      theme,
      watermark: true,
    })
      .then(({ b64, width, height }) => {
        return takeSnapshot({
          variables: {
            data: b64,
            width,
            height,
          },
        });
      })
      .then(({ data }) => {
        if (download) {
          downloadSnapshot(data.takeSnapshot.img, data.takeSnapshot.filename);
        }
        return;
      })
      .finally(() => setLoading(false));
  };

  return { loading, img, snapshot };
};
